import Anchor from './Anchor';

const Support = () => {
    const handleButtonClick = () => {
        // window.open('https://s010.med.cornell.edu/wcmc/make-a-donation.html?dept=Laboratory of Nancy Du, PhD');
        window.open('https://engage.weill.cornell.edu/give?fund=b19d822b-1139-42b4-bfe6-7518bcb0b6c2');
    }

    return (
        <section className="page">
            <div className="page-header">
                <div className="page-title">Support Us</div>
            </div>
            <article className="page-content">
                <div className="in-page-title">
                    Support Cancer Research Today!
                </div>
                <div>
                    <iframe id="homeMediaFrame" src="https://www.youtube.com/embed/PmVCPHs-dtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="support-us-video-embed"></iframe>
                </div>
                <div>
                    A gift from you will help accelerate safer, more effective strategies to prevent and treat metastatic cancer, with an immediate focus on breast cancer and pancreatic cancer.<br />
                    <b>Why this matters</b><br />
                    <ul>
                        <li>Most cancer deaths are caused by metastasis—when cancer spreads to vital organs.</li>
                        <li>Once cancer has spread, current treatments rarely cure the disease. We need earlier interception and treatments that are more effective and less toxic.</li>
                    </ul>
                    <b>What your gift makes possible</b><br />
                    <ul>
                        <li>Critical experiments that translate discoveries into new treatment strategies for patients.</li>
                        <li>Support for team members who keep the science moving.</li>
                        <li>Bridge funding between grants to maintain momentum.</li>
                    </ul>
                    <b>Select advances in the Du Lab</b><br />
                    <ul>
                        <li>Showed that when cancers make too much Bcl-xL protein, this protein can move into the cell's nucleus and drive cancer spread, helping explain why drugs that target only its role in blocking cell death have fallen short.</li>
                        <li>Identified a specific form of RHAMM protein as a biomarker and driver of metastasis across multiple cancers, guiding better risk stratification and targeted strategies.</li>
                        <li>Advanced precisely controlled, low-dose carbon monoxide (CO) approaches—using a molecule our bodies naturally produce—to inhibit cancer metastasis.</li>
                    </ul>
                    <b>Ways to give</b><br />
                    To support Dr. Du's research, please scan or click the QR code below<br />
                    <div class="donate-link">
                        <img src="images/support-qr.png" alt="QR Code: Scan to Support" onClick={handleButtonClick} />
                    </div>
                    <br />
                    To donate by check<br />
                    Please make your check payable to <b>Weill Cornell Medical College</b>, in the memo please note: <b>Dr. Nancy Du Laboratory</b> and mail it to:<br />
                    Weill Cornell Medicine<br />
                    Office of External Affairs<br />
                    Attn: Giulia Gabrielli<br />
                    P.O. Box 22497<br />
                    New York, NY 10087-2497<br />
                    <br />
                    For more donation methods, please contact
                    <div className="indent-double">
                        Giulia Gabrielli<br />
                        TEL:  +1.646.962.9574<br />
                        Email: <Anchor url="mailto:Gig2006@med.cornell.edu" label="Gig2006@med.cornell.edu" target="_self" />
                    </div>
                    <br />
                    Or simply print the <a href="Support Dr. Nancy Du.pdf" target="_blank">flyer</a> and help us to spread the words.
                    <br /><br />
                </div>
            </article>
        </section>
    );
}

export default Support;